import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/',
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/company/learnpaths/overview/$learnpathId/details',
      params: { learnpathId: params.learnpathId },
      search,
      replace: true,
    })
  },
})
